import Api from "./Api";

export const AdminUserService = {

    getUsers: async () => {

        const res = await Api.get("/admin-users");
        return res.data;

    },

    createUser: async (data) => {

        const res = await Api.post("/admin-users", data);
        return res.data;

    },

    updateUser: async (id, data) => {

        const res = await Api.put(`/admin-users/${id}`, data);
        return res.data;

    },

    deleteUser: async (id) => {

        const res = await Api.delete(`/admin-users/${id}`);
        return res.data;

    }

};